export interface XIconProps {
  strokeColor?: string;
  strokeWidth?: string;
}

export default function XIcon({ strokeColor = '#A9A9A9', strokeWidth = '2', ...rest }: XIconProps) {
  return (
    <svg
      width='10'
      height='10'
      viewBox='0 0 10 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path d='M1 1L9 9' stroke={strokeColor} strokeWidth={strokeWidth} />
      <path d='M8.99988 1L0.999878 9' stroke={strokeColor} strokeWidth={strokeWidth} />
    </svg>
  );
}
